import React, { ReactChild } from "react";
import Responsive, { useMediaQuery } from "react-responsive";
import { breakpoints } from "src/styles/createBreakpoints";

export interface ResponsiveProps {
    children: ReactChild | {};
}

const { sm, md } = breakpoints;

const Desktop = (props: ResponsiveProps) => <Responsive {...props} minWidth={md} />;
const NotDesktop = (props: ResponsiveProps) => <Responsive {...props} maxWidth={md - 1} />;
const Tablet = (props: ResponsiveProps) => <Responsive {...props} minWidth={sm} maxWidth={md - 1} />;
const Mobile = (props: ResponsiveProps) => <Responsive {...props} maxWidth={sm - 1} />;
const NotMobile = (props: ResponsiveProps) => <Responsive {...props} minWidth={sm} />;

const useDesktopMediaQuery = () => {
    return useMediaQuery({ minWidth: md });
};

const useMobileMediaQuery = () => {
    return useMediaQuery({ maxWidth: sm - 1 });
};

const useMediaQueries = () => {
    const desktop = useMediaQuery({ minWidth: md });
    const notDesktop = useMediaQuery({ maxWidth: md - 1 });
    const tablet = useMediaQuery({ minWidth: sm, maxWidth: md - 1 });
    const mobile = useMediaQuery({ maxWidth: sm - 1 });
    const notMobile = useMediaQuery({ minWidth: sm });
    return {
        desktop,
        notDesktop,
        tablet,
        mobile,
        notMobile,
    };
};

export { Desktop, NotDesktop, Mobile, NotMobile, Tablet, useDesktopMediaQuery, useMobileMediaQuery, useMediaQueries };

export default NotDesktop;
